// Vuex connections module mutations types
export const FILL_LIST = "FILL_LIST";
export const FILL_LIST_COUNT = "FILL_LIST_COUNT";
export const FILL_CALENDAR = "FILL_CALENDAR";
